import { handleActions } from "redux-actions";

import {
  SET_LOADING,
  FETCH_CURRENT_USER_SUCCESS,
  FETCH_FILTERS_SUCCESS,
  FETCH_DATA_SUCCESS,
  UPDATE_FILTER,
  SET_UPDATES_LOADING,
  SET_FILTERS_DIRTY,
  RESET_FILTER,
  SET_MODULE_VIEW
} from "./attritionAndCancelReasonsSaga";

export const initialState = {
  currentUser: {},
  filters: {},
  initialRequest: false,
  moduleView: [
    { id: "monthly", name: "Monthly" },
    { id: "rolling30Days", name: "Rolling 30" }
  ],
  selectedFilters: {
    date: "",
    membership_types: [],
    moduleView: { id: "monthly", name: "Monthly" }
  },
  dataPoints: [],
  areaChart: [],
  pieCharts: [],
  isLoading: true,
  updatesLoading: false,
  filtersDirty: false
};

export default handleActions(
  {
    [SET_LOADING]: (state, action) => ({
      ...state,
      isLoading: action.payload
    }),
    [SET_UPDATES_LOADING]: (state, action) => ({
      ...state,
      updatesLoading: action.payload
    }),
    [SET_FILTERS_DIRTY]: (state, action) => ({
      ...state,
      filtersDirty: action.payload
    }),
    [FETCH_CURRENT_USER_SUCCESS]: (state, action) => ({
      ...state,
      initialRequest: true,
      currentUser: action.payload,
      selectedFilters: {
        ...state.selectedFilters,
        date: action.payload.calendarEndDate
      }
    }),
    [FETCH_FILTERS_SUCCESS]: (state, action) => ({
      ...state,
      filters: action.payload,
      selectedFilters: {
        ...state.selectedFilters,
        membership_types: action.payload.membership_types
      }
    }),
    [FETCH_DATA_SUCCESS]: (
      state,
      { payload: { data_points, pie_charts, year_over_year_chart } }
    ) => ({
      ...state,
      dataPoints: data_points,
      pieCharts: pie_charts,
      areaChart: year_over_year_chart
    }),
    [UPDATE_FILTER]: (state, { payload: { key, data } }) => ({
      ...state,
      filtersDirty: true,
      selectedFilters: {
        ...state.selectedFilters,
        [key]: data
      }
    }),
    [RESET_FILTER]: (state) => ({
      ...state,
      filtersDirty: initialState.filtersDirty,
      selectedFilters: {
        membership_types: state.filters.membership_types,
        date: state.currentUser.calendarEndDate,
        moduleView: state.selectedFilters.moduleView
      }
    }),
    [SET_MODULE_VIEW]: (state, action) => ({
      ...state,
      selectedFilters: {
        ...state.selectedFilters,
        moduleView: action.payload
      }
    })
  },
  initialState
);
